import { makeStyles } from '@material-ui/core/styles';
import Constants from '../../Constants';
import {primaryText, white} from '../../utils/CssGlobalVariables';

export const usePortingStyle = makeStyles(theme => ({
    inputLabelStar: {
        '&::after': {
            // increase the specificity for the pseudo class
            content: '"*"',
            display: 'inline-block',
            color: 'red',
            textAlign: 'center',
        },
    },
    paper: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        boxShadow: '0 3px 20px rgba(0,0,0,.14118) !important',
        borderRadius: '9px ',
        [theme.breakpoints.up(1000 + theme.spacing(3) * 2)]: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(3.125),
            padding: theme.spacing(3),
        },
    },
    eirPorting: {
        '@media (max-width: 767px)': {
            textAlign: 'center',
        },
        '& .mobileViewLeft': {
            '@media (max-width: 767px)': {
                marginLeft: 'auto',
            },
        },
        '& .mobileViewRight': {
            '@media (max-width: 767px)': {
                marginRight: 'auto',
            },
        },
        '& a': {
            textDecoration: 'none',
        },
        '& .notification': {
            color: 'black',
            fontSize: '16px',
            fontFamily: ' gt-walsheim-medium',
            '@media (max-width: 1024px)': {
                fontSize: '14px',
            },
        },
        '& .editLayout': {
            color: 'black',
            fontSize: '16px',
            fontFamily: ' gt-walsheim-medium',
            '@media (min-width:281px) and (max-width: 767px)': {
                fontSize: '16px',
                marginBottom: '10px',
            },
            '@media  (max-width: 280px)': {
                fontSize: '13px',
                marginBottom: '10px',
            },
            '@media (min-width:768px) and ( max-width: 1023px)': {
                fontSize: '13px',
            },
        },
        '& .mobileViewEdit': {
            '@media (max-width: 767px)': {
                margin: '-50px auto 0px;',
            },
        },
        '& .EditText': {
            fontSize: '18px !important',
            fontFamily: ' gt-walsheim-medium',
            textAlign: 'center',
            padding: '6px',
            width: '100px !important',
            border: `1px solid ${primaryText} !important`,
            color: `${primaryText} !important`,
            float: 'right',

            marginTop: '-15px!important',
            '@media (max-width: 767px)': {
                textDecoration: 'none',
                float: 'none',
                margin: 'auto',
            },
        },
        '& .AlignEdit': {
            marginRight: '10px',
        },
        '& .tickposition': {
            '&::after': {
                margin: '0px 10px 0px 15px !important',
            },
        },
        '& .tickright': {
            '&::after': {
                content: '""',
                display: 'inline-block',
                lineHeight: '1rem',
                position: 'absolute',
                width: '20px',
                textAlign: 'center',
                marginTop: '8px',
                marginLeft: '-27px',
                height: '20px',
                borderRadius: '100%',
                backgroundImage:
                    'url("/opencms/export/sites/default/.galleries/eir/icons/tick-icon.svg")',
                backgroundRepeat: 'no-repeat',
            },
        },
        '& .EditIcon': {
            '&::after': {
                content: '""',
                display: 'inline-block',
                lineHeight: '1rem',
                position: 'absolute',
                width: '20px',
                textAlign: 'center',
                height: '20px',
                borderRadius: '100%',
                backgroundImage:
                    'url("/opencms/export/sites/default/.galleries/eir/icons/edit-icon.svg")',
                backgroundRepeat: 'no-repeat',
            },
        },
        '& .mobileBorder': {
            '@media (max-width: 767px)': {
                border: '1px solid #ccc',
                padding: '0px',
                height: '40px',
                marginTop: '8px',
                borderRadius: '0px 4px 4px 0px',
            },
            '@media (min-width:360px) and (max-width: 375px)': {
                maxWidth: '44px',
            },
            '@media (min-width:411px) and (max-width: 414px)': {
                maxWidth: '52px',
            },
            '@media (min-width:280px) and (max-width: 320px)': {
                maxWidth: '38px',
            },
            '@media (min-width:415px) and (max-width: 450px)': {
                maxWidth: '59px',
            },
        },
        '& .mobilePaddingRight': {
            '@media (max-width: 767px)': {
                paddingRight: '0px',
            },
            '& .MuiInputBase-root': {
                '@media (max-width: 767px)': {
                    borderRadius: '4px 0px 0px 4px !important',
                },
            },
        },
        '& .MuiInputBase-root.Mui-disabled': {
            color: 'black',
        },
        '& .MuiIconButton-label': {
            fontSize: '20px',
        },
        '& .required': {
            paddingRight: '10px',
            color: '#e40046',
        },
        '& .MuiFormGroup-root': {
            '@media (max-width: 767px)': {
                display: 'inline-block',
            },
        },
        '& .mobileHide': {
            '@media (max-width: 1024px)': {
                display: 'none',
            },
        },
        '& .mobileHideGrid': {
            '@media (max-width: 767px)': {
                display: 'none',
            },
        },
        '& button': { outline: 'none' },
        '& .eirotpComp': { margin: '20px 0px' },
        '& .errorMessage': {
            width: '100%',
            marginTop: '.25rem',
            fontSize: 16,
            color: '#e40046',
            display: 'block',
            '@media (max-width: 767px)': {
                textAlign: 'left',
                fontSize: 14,
            },
        },

        '& .questionIcon': {
            display: 'inline-block',
            lineHeight: '1rem',
            fontSize: '25px',
            marginTop: '8px',
            // width: '20px',
            // textAlign: 'center',

            // height: '20px',
            // borderRadius: '100%',
            // backgroundImage:
            //     'url("https://testwww10.eir.ie/opencms/export/sites/default/.galleries/eir/icons/question-icon.svg")',
            // backgroundRepeat: 'no-repeat',
        },
        '& .iconWidth': {
            width: '40px !important',
            maxWidth: '40px',
            '@media (max-width: 767px)': {
                width: '100%',
                maxWidth: '100%',
            },
            '@media (min-width:767px) and (max-width: 1023px)': {
                width: '100%',
                maxWidth: '29px',
            },
        },
        '& .iconTab': {
            '@media (min-width:767px) and (max-width: 1023px)': {
                padding: '8px 0px !important',
            },
        },
        '& .calenderIcon': {
            display: 'inline-block',
            width: '23px',
            textAlign: 'center',
            outline: 'none',
            height: '20px',
            backgroundImage:
                'url("/opencms/export/sites/default/.galleries/eir/icons/calendar-icon.svg")',
            backgroundRepeat: 'no-repeat',
            '&:focus,&:hover': {
                outline: 'none',
            },
            '@media (max-width: 767px)': {
                marginRight: '-12px',
            },
            '@media (min-width:767px) and (max-width: 1024px)': {
                marginRight: '-20px',
            },
        },

        '& .clockIcon': {
            '&::after': {
                content: '""',
                display: 'inline-block',
                lineHeight: '1rem',
                position: 'absolute',
                width: '20px',
                textAlign: 'center',
                marginTop: '8px',
                marginLeft: '-36px',
                height: '20px',
                borderRadius: '100%',
                backgroundImage:
                    'url("/opencms/export/sites/default/.galleries/eir/icons/timer-icon.svg")',
                backgroundRepeat: 'no-repeat',
            },
        },

        '& .radioText': {
            color: `${primaryText}`,
            marginRight: '30px',
            fontSize: '20px',
            marginTop: '6px',
            fontFamily: 'eir-medium !important',
            '@media (max-width: 767px)': {
                textAlign: 'center',
                margin: 'auto',
                fontSize: '18px',
            },
            '& .questionIcon': {
                marginTop: '0',
                marginLeft: '10px',
                verticalAlign: 'bottom',
            },
        },
        '& .radioLayout': {
            background: `${white}`,
            fontWeight: 'bold',
            margin: '0px 0px 0px 20px',
            borderRadius: '20px',
            height: '39px',
            fontSize: '14px',
            width: '90px',
            '@media (max-width: 767px)': {
                margin: '20px 0px 0px 20px',
            },
        },
        '& .greylLayout': {
            border: '1px solid #888B8D',
            color: '#888B8D',
        },
        '& .purpleLayout': {
            border: `1px solid ${primaryText} !important`,
            color: `${primaryText} !important`,
        },

        '& .cancelBtn': {
            borderRadius: '2rem',
            fontSize: 15,
            textTransform: 'initial',
            fontWeight: 'bold',
            padding: theme.spacing(1.25, 5),
            border: `1px solid ${primaryText}`,
            background: `${white}`,
            color: `${primaryText}`,

            marginRight: '10px',
            '@media (min-width: 281px) and (max-width: 767px)': {
                float: 'none',
                padding: theme.spacing(1, 4),
                fontSize: 14,
            },
            '@media (max-width: 280px)': {
                padding: '5px 20px',
                float: 'none',
                fontSize: 14,
            },
            '@media (min-width:768px) and (max-width: 1024px)': {
                padding: theme.spacing(1, 4),
                fontSize: 14,
            },
            '&:focus,&:hover': {
                outline: 'none',
            },
        },
        '& .mobileFloat': {
            float: 'right',
            '@media (max-width: 767px)': {
                float: 'none',
            },
        },
        '& .pupleBtn': {
            borderRadius: '2rem',
            fontSize: 15,
            textTransform: 'initial',
            fontWeight: 'bold',
            padding: theme.spacing(1.25, 5),
            border: '1px solid '+Constants.siteTheme.primaryTheme,
            background: Constants.siteTheme.primaryTheme,
            color: `${white}`,
            float: 'right',
            '@media (min-width:281px) and (max-width: 767px)': {
                float: 'none',
                padding: theme.spacing(1, 4),
                fontSize: 14,
            },
            '@media (max-width: 280px)': {
                padding: '5px 20px',
                float: 'none',
                fontSize: 14,
            },
            '@media (min-width:768px) and (max-width: 1024px)': {
                float: 'right',
                padding: theme.spacing(1, 4),
                fontSize: 14,
            },
            '&:focus,&:hover': {
                outline: 'none',
            },
        },
        '& .greyBtn': {
            borderRadius: '2rem',
            fontSize: 15,
            textTransform: 'initial',
            fontWeight: 'bold',
            padding: theme.spacing(1.25, 5),
            border: 'transparent',
            background: 'rgba(0, 0, 0, 0.12)',
            // color: 'black',
            float: 'right',
            '@media (min-width:281px) and (max-width: 767px)': {
                float: 'none',
                padding: theme.spacing(1, 4),
                fontSize: 14,
            },
            '@media (max-width: 280px)': {
                padding: '5px 20px',
                float: 'none',
                fontSize: 14,
            },
            '@media (min-width:768px) and (max-width: 1024px)': {
                float: 'right',
                padding: theme.spacing(1, 4),
                fontSize: 14,
            },
            '&:focus,&:hover': {
                outline: 'none',
            },
        },
    },
}));
